import { render, staticRenderFns } from "./LmListBuilder.vue?vue&type=template&id=2be5d804&scoped=true"
import script from "./LmListBuilder.vue?vue&type=script&lang=js"
export * from "./LmListBuilder.vue?vue&type=script&lang=js"
import style0 from "./LmListBuilder.vue?vue&type=style&index=0&id=2be5d804&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2be5d804",
  null
  
)

export default component.exports